import { requestInFlight, requestSuccess, requestError } from 'state/modules/entity';
import { Dispatch } from 'redux';

import { Resource, UserFavorite } from 'types';

import {
  createUserFavorite as postUserFavorite,
  getResources,
  getBookFilters,
  getUserFavorites,
  deleteUserFavorite,
  getSupportResources,
  getSupportResourcesForProduct,
  getSupportResource
} from 'api';
import { updateAppCounter } from 'state/modules/app';
import { batch } from 'react-redux';

export const fetchResources = (bookId?: number) => async (dispatch: Dispatch, getState) => {
  dispatch(requestInFlight());
  const {
    app: { currentWorkbook }
  } = getState();
  try {
    const { data } = await getResources(bookId || currentWorkbook.id, {
      include: ['tags']
    }); // CSC - need to re-add pages later...
    dispatch(requestSuccess({ resources: data }));
  } catch (error) {
    dispatch(requestError(error));
  }
};

export const fetchFilterTags = (bookId?: number) => async (dispatch: Dispatch, getState) => {
  dispatch(requestInFlight());
  const {
    app: { currentWorkbook }
  } = getState();
  try {
    const { data: filterGroups } = await getBookFilters(bookId || currentWorkbook.id);
    dispatch(requestSuccess({ filterGroups }, { keyByProperty: 'filter' }));
  } catch (error) {
    dispatch(requestError(error));
  }
};

export const fetchFavoriteResources = (productCurriculumId?: number) => async (
  dispatch: Dispatch,
  getState
) => {
  dispatch(requestInFlight());

  const {
    app: { currentWorkbook }
  } = getState();

  const params = {
    include: ['resource', 'clickAway'],
    productCurriculumId: productCurriculumId || currentWorkbook.products[0].productCurriculumId
  };

  try {
    const { data: favoriteResources } = await getUserFavorites(params);
    return dispatch(requestSuccess({ favoriteResources }));
  } catch (error) {
    dispatch(requestError(error));
  }
};

export const createUserFavorite = (resource: Resource) => async (dispatch: Dispatch) => {
  const favorite: UserFavorite = {
    ...(resource.resourceTypeId ? { resourceId: resource.id } : { clickAwayId: resource.id })
  };

  dispatch(requestInFlight());
  try {
    const response = await postUserFavorite(favorite);
    const userFavorite = {
      ...response.data,
      ...(resource.resourceTypeId ? { resource: resource } : { clickAway: resource })
    };
    dispatch(
      requestSuccess({ userFavorite }, { type: 'RESOURCE_FAVORITE.CREATE_FAVORITE_SUCCESS' })
    );
    dispatch(updateAppCounter('increment'));
  } catch (error) {
    dispatch(requestError(error));
  }
};

export const removeUserFavorite = (favoriteId: number) => async (dispatch: Dispatch) => {
  if (favoriteId) {
    dispatch(requestInFlight());
    try {
      await batch(async () => {
        await deleteUserFavorite(favoriteId);
        dispatch(
          requestSuccess({ favoriteId }, { type: 'RESOURCE_FAVORITE.REMOVE_FAVORITE_SUCCESS' })
        );
        dispatch(updateAppCounter('decrement'));
      });
    } catch (error) {
      dispatch(requestError(error));
    }
  }
};
export const fetchSupportResources = () => getSupportResources();

export const fetchSupportResourcesForProduct = (productCurriculumId: number) => async dispatch => {
  dispatch(requestInFlight());
  try {
    const { data: supportResources } = await getSupportResourcesForProduct(productCurriculumId);

    const filteredResources = supportResources.reduce((acc, curr) => {
      curr.tags.forEach(x => {
        if (x.tag === 'Support') {
          acc?.[x.value] ? acc[x.value].push(curr) : (acc[x.value] = [curr]);
        }
        return;
      });
      return acc;
    }, {});

    return await dispatch(requestSuccess({ supportResources: filteredResources }));
  } catch (e) {
    dispatch(requestError(e));
  }
};

export const fetchSupportResource = (resourceId: number) => getSupportResource(resourceId);
